import { apiInstance } from "../config/api";

export const paymentService = {
  async verifyPayment(reference: string, token?: string) {
    const response = await apiInstance.get(`/payment/verify/${reference}`, token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : undefined);
    return response.data;
  },

  async verifyPaymentResult(reference: string, token?: string) {
    const response = await apiInstance.get(`/payment/verify/${reference}`, {
      ...(token
        ? {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        : {}),
      validateStatus: () => true,
    });

    return {
      ok: response.status >= 200 && response.status < 300,
      status: response.status,
      data: response.data,
    };
  },
};